import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { useEffect, useState } from 'react';
import { useStadium } from 'stadium/StadiumHooks';
import axios from 'axios';
import Documents from './components/Documents/Documents';
import Homepages from './components/Homepages/Homepages';
import Richtext from './components/Richtext/Richtext';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
var RichtextPage = function RichtextPage(props) {
  var text = props.root.richtext.text;
  return /*#__PURE__*/_jsx("div", {
    style: {
      padding: '50px'
    },
    children: /*#__PURE__*/_jsx(Richtext, {
      root: {
        text: text
      }
    })
  });
};
var buildCMSUrl = function buildCMSUrl(user, _ref) {
  var isVisualizer = _ref.isVisualizer,
    dataHost = _ref.dataHost,
    urlSearchParams = _ref.urlSearchParams,
    currentPage = _ref.currentPage;
  if (isVisualizer) {
    return "".concat(dataHost, "?").concat(urlSearchParams.toString());
  }
  var userFilters = ['category', 'channel', 'globalRole', 'leadCategory', 'locale', 'partnerId', 'tier', 'userRole', 'mode'];
  var queryString = function queryString() {
    return userFilters.map(function (filter) {
      var key = filter === 'partnerId' ? 'account' : filter.toLocaleLowerCase();
      var value = user[filter];
      if (value && (filter === 'globalRole' || filter === 'userRole')) {
        value = value.replace(/\s+/g, '');
      }
      return "".concat(key, "=").concat(typeof value === 'string' || typeof value === 'number' ? value : 'none');
    }).join('&')
    // @ts-expect-error
    .concat("&page=".concat(((currentPage === null || currentPage === void 0 ? void 0 : currentPage.hash) || (currentPage === null || currentPage === void 0 ? void 0 : currentPage.pathname) || '').split('/').pop().replace('DOC', 'salesinformation').replace('privacy', 'privacypolicy')));
  };
  return "".concat(dataHost).concat(queryString() ? "?".concat(queryString()) : '');
};
var ClientLoader = function ClientLoader(props) {
  var _useStadium = useStadium(),
    isStadiumReady = _useStadium.stadiumReady,
    user = _useStadium.user,
    sendPageViewEvent = _useStadium.analyticsHooks.sendPageViewEvent;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    cmsData = _useState2[0],
    setCmsData = _useState2[1];
  var fetchData = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _response$data, response;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return axios.get(buildCMSUrl(user, props), {
              withCredentials: true
            });
          case 3:
            response = _context.sent;
            if (response.status === 200) {
              setCmsData(response.data);
            } else if (response.status === 401 && (_response$data = response.data) !== null && _response$data !== void 0 && _response$data.login) {
              window.location.href = response.data.login;
            }
            _context.next = 10;
            break;
          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](0);
            // eslint-disable-next-line no-console
            console.error("Unable to fetch data from CMS", _context.t0);
          case 10:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 7]]);
    }));
    return function fetchData() {
      return _ref2.apply(this, arguments);
    };
  }();
  useEffect(function () {
    if (isStadiumReady && user && cmsData === undefined) {
      void fetchData();
      sendPageViewEvent("homepage", "Homepages");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cmsData, isStadiumReady]);

  // eslint-disable-next-line @typescript-eslint/no-shadow
  var route = React.useMemo(function () {
    if (cmsData) {
      var p1 = cmsData.p1,
        p5 = cmsData.p5,
        termsandconditions = cmsData.termsandconditions,
        useagreement = cmsData.useagreement,
        privacypolicy = cmsData.privacypolicy;
      if (p1) {
        return /*#__PURE__*/_jsx(Homepages
        // @ts-expect-error
        , _objectSpread(_objectSpread({}, cmsData), props));
      }
      // @ts-expect-error
      if (p5) return /*#__PURE__*/_jsx(Documents, _objectSpread(_objectSpread({}, cmsData.p5[0]), props));
      var richTextProps = termsandconditions || useagreement || privacypolicy;
      // @ts-expect-error
      if (richTextProps) return /*#__PURE__*/_jsx(RichtextPage, _objectSpread(_objectSpread({}, richTextProps), props));
    }
    return null;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cmsData]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [" ", route, " "]
  });
};
export default ClientLoader;